import styled from "styled-components";

const NewContainer = styled.section`
    background: linear-gradient(135deg, #ff3d00, #ff5e3a);
    padding: 40px 20px;
    color: #fff;
`;

const NewCardsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    max-width: 1000px;
    margin: 0 auto;
`;

const NewCard = styled.div`
    flex: 1;
    min-width: 250px;
    max-width: 280px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease;

    &:hover {
        transform: translateY(-6px);
        box-shadow: 0 6px 8px rgba(0, 0, 0, 0.3);
    }
`;

const NewCardImage = styled.img`
    width: 100%;
    height: 180px;
    object-fit: cover;
`;

const NewCardContent = styled.div`
    padding: 15px;
    text-align: center;
`;

const NewCardTitle = styled.h3`
    font-size: 24px;
    margin-bottom: 10px;
    color: #ffeb3b;
`;

const NewCardDescription = styled.p`
    font-size: 16px;
    line-height: 1.4;
    color: #e0e0e0;
`;

const PrivilegesInfinity = () => {
  return (
    <NewContainer>
      <NewCardsContainer>
        <NewCard>
          <NewCardImage src="/reacti3.jpg" alt="Kreative Ideen" />
          <NewCardContent>
            <NewCardTitle>Kreative Ideen</NewCardTitle>
            <NewCardDescription>
              Nutze einen konstanten Fluss innovativer Ideen, die deine Geschäftspraktiken revolutionieren.
            </NewCardDescription>
          </NewCardContent>
        </NewCard>
        <NewCard>
          <NewCardImage src="/reacti2.jpg" alt="Integrierte Lösungen" />
          <NewCardContent>
            <NewCardTitle>Vollständige Lösungen</NewCardTitle>
            <NewCardDescription>
              Entdecke ein umfassendes Angebot an technologischen Dienstleistungen zur Optimierung aller Aspekte deiner Organisation.
            </NewCardDescription>
          </NewCardContent>
        </NewCard>
        <NewCard>
          <NewCardImage src="/reacti1.jpg" alt="Technologie-Experten" />
          <NewCardContent>
            <NewCardTitle>Technikspezialisten</NewCardTitle>
            <NewCardDescription>
              Unser Expertenteam passt Strategien an, um deine digitale Evolution effektiv voranzutreiben.
            </NewCardDescription>
          </NewCardContent>
        </NewCard>
      </NewCardsContainer>
    </NewContainer>
  );
};
export default PrivilegesInfinity;